module.exports = __webpack_public_path__ + "assets/c73108f1578939d4f818255e1d916509.mp4";